import { Box } from '@chakra-ui/react'
import styled from '@emotion/styled'

import theme from 'styles/theme'

export const RentalSectionWrapper = styled(Box)`
  @media screen and (max-width: ${theme.token('breakpoints.lg')}) {
    height: calc(100vh - 136px);
    padding-bottom: 150px;
    overflow: auto;
  }
`

export const DatePickersWrapper = styled(Box)`
  display: block;

  > * {
    margin: 0 0 20px;
  }

  @media (min-width: 600px) {
    display: flex;
    align-items: flex-start;
    margin-left: -10px;
    margin-right: -10px;

    > * {
      margin-left: 10px;
      margin-right: 10px;
      flex: 1;
    }
  }
`

export const AdditionalOptionsWrapper = styled(Box)`
  display: block;

  > * {
    margin: 0 0 20px;
  }

  @media (min-width: 600px) {
    display: flex;
    align-items: flex-start;
    margin-left: -10px;
    margin-right: -10px;

    > * {
      margin-left: 10px;
      margin-right: 10px;
      flex: 1 1 50%;
    }
  }
`
